<template>
  <b-input-group class="campaign-select-container-light justify-content-between w-100">
    <vue-opti-select-light
      ref="selectorType"
      class="optimizer-select-type campaign-optimizer-select"
      :options="[{ content: 'Select Filter', value: null }, { content: 'Include', value: 'INCLUDE' }, { content: 'Exclude', value: 'EXCLUDE' }]"
      v-model="model.type"
      @change="(option) => { $emit('input', { entities: model.entities , type: option}) }"
      button-placeholder="Select Type"
      single
      button-block
    />
    <vue-opti-select-light
      ref="parentEntityDropdown"
      class="optimizer-select campaign-optimizer-select flex-grow-1"
      :options="$_options"
      v-model="model.entities"
      unique-key="id"
      label-key="name"
      button-type="tag"
      option-type="checkbox"
      :button-placeholder="`Search ${label}s...`"
      @change="(value) => { $emit('input', {entities: value, type: model.type}) }"
      :disabled="$c_allowEdit"
      button-block
      debounce
      searchable
    >
      <template #TAG_LABEL="{ option }">
        <img class="acc-item-icon" :src="`/sh_static/accounts/${option.traffic_source_unique_name}.png`" />
        <div class="acc-item-name">
          {{ option.name }}
        </div>
      </template>
      <template #ITEM="{ option }">
        <img class="acc-item-icon" :src="`/sh_static/accounts/${option.traffic_source_unique_name}.png`" />
        <div class="acc-item-name">
          {{ option.name }}
        </div>
      </template>
    </vue-opti-select-light>
    <b-dropdown v-if="enableFilter" :disabled="$c_allowEdit" class="filter-dropdown" slot="append" :no-flip="true" @hidden="$_dropdownHidden" right>
      <template #button-content>
        <i class="fa fa-filter"></i> Add {{ label }}s
      </template>
      <div class="searchCampaignItem">
        <b-input v-model="$c_searchModel" placeholder="Search..." autocomplete="off" class="searchCampaignInput w-100" />
        <div class="searchInfo d-flex justify-content-between">
          <span class="count-display">
            Found: <i v-if="statsLoading" class="fa fa-refresh fa-spin"></i><template v-else>{{ $c_countSearchCampaings }}</template>
          </span>
          <b-btn :disabled="statsLoading" class="add-btn" size="sm" @click="$_addSearchCampaigns">
            Add
          </b-btn>
        </div>
      </div>
      <b-dropdown-header v-for="(item, i) in $c_filter" :key="i">
        <b-form-checkbox v-model="item.selected" @change="(value) => {$_selectItem(item, value)}">
          <div class="d-inline-block" v-html="item.content"></div>
          <div class="d-inline-block counter">
            (<template v-if="typeof item.type !== 'undefined' && typeof item.status !== 'undefined'">
              {{ item.ids.length }}
            </template>)
          </div>
        </b-form-checkbox>
      </b-dropdown-header>
      <b-dropdown-item @click="$_clearForm" class="clear-form-item">
        <i class="fa fa-times text-danger"></i> Clear
      </b-dropdown-item>
    </b-dropdown>
  </b-input-group>
</template>

<script>
import { uniqBy, debounce } from 'lodash';
import { getTrafficSourceLogo } from '@sh/helpers';
import { TrafficSource } from '@sh/types';

export default {
  name: 'EntityParentSelector',
  props: {
    value: { type: Object, default: () => ({ entities: [], type: null, parent_level: null }) },
    disabled: { type: Boolean, default: false },
    enableFilter: { type: Boolean, default: true },
    trafficSourceFilter: { type: Array, default: () => [] },
    trackerAccountFilter: { type: Array, default: () => [] },
    customFilter: { type: [Object, null], default: null },
    enableFilterAllByType: { type: Boolean, default: false }, // TODO filter response
    managed: { type: Boolean, default: true },
    archived: { type: Boolean, default: false },
    label: { type: String },
    mode: { type: String },
  },
  data() {
    return {
      model: { entities: [], type: null, parent_level: null },
      stats: [],
      search: '',
      searchModel: '',
      statsLoading: false,
      preloader: true, // Unused
    };
  },
  computed: {
    $c_platformFilter() {
      const filter = [
        // {content: this.$_getItemContent('Add All'), selected: false},
        // {enabled: true, content: this.$_getItemContent('Add Active Only'), selected: false},
        // {enabled: false, content: this.$_getItemContent('Add Paused Only'), selected: false},
      ];
      let trafficSources = [TrafficSource.AmazonDSP];
      /* ******** Filter by allowed Traffic Source Type ********* */
      if (this.trafficSourceFilter.length === 1) {
        trafficSources = trafficSources.filter((type) => type === this.trafficSourceFilter[0]);
      } else if (this.trafficSourceFilter.length > 1) {
        trafficSources = trafficSources.filter((type) => this.trafficSourceFilter.indexOf(type) > -1 || typeof type === 'undefined');
      }
      /* ******** ************************************* ********* */
      trafficSources.forEach((type) => {
        if (this.enableFilterAllByType) filter.push({ type, status: 'ALL', content: this.$_getItemContent('Add All', type), selected: false });
        filter.push(
          {
            type, status: 'RUNNING', enabled: true, content: this.$_getItemContent('Add Active', type), selected: false,
          },
          {
            type, status: 'ACTIVE', enabled: true, content: this.$_getItemContent('Add Enabled', type), selected: false,
          },
          {
            type, status: 'NOT ACTIVE', enabled: true, content: this.$_getItemContent('Add Not Active', type), selected: false,
          },
          {
            type, status: 'PAUSED', enabled: false, content: this.$_getItemContent('Add Paused', type), selected: false,
          },
          {
            type, status: 'OUT OF FUNDS', enabled: false, content: this.$_getItemContent('Add Out Of Founds', type), selected: false,
          },
          {
            type, status: 'OTHER', enabled: false, content: this.$_getItemContent('Add Other', type), selected: false,
          },
        );
      });

      return filter;
    },
    $c_statResult() {
      const dimensions = {};
      this.stats.forEach((item) => {
        if (!dimensions[item.traffic_source_unique_name]) dimensions[item.traffic_source_unique_name] = {};
        dimensions[item.traffic_source_unique_name][item.statusts] = item.ids;
      });
      return dimensions;
    },
    $c_filter() {
      const filter = [];
      console.log(this.$c_platformFilter);
      this.$c_platformFilter.forEach((item) => {
        if (this.$c_statResult[item.type] && this.$c_statResult[item.type][item.status]) {
          const newItem = { ...item, ids: this.$c_statResult[item.type][item.status] };
          filter.push(newItem);
        }
      });
      return filter;
    },
    $c_searchModel: {
      get() {
        return this.searchModel;
      },
      set(value) {
        // Debounce set value
        this.$options.debounceSetSearchFunction(value);
      },
    },
    $c_countSearchCampaings() {
      return this.search === '' ? '' : this.$c_filter.reduce((total, { ids }) => total + ids.length, 0);
    },
    $c_allowEdit() {
      return !(this.model.type && this.model.type.value);
    },
  },
  async created() {
    this.model.parent_level = this.value.parent_level;
    this.$watch('customFilter', () => {
      this.$refs.parentEntityDropdown.resetOptions();
      this.$_updateStats();
    });

    this.$watch('trackerAccountFilter', () => {
      this.$refs.parentEntityDropdown.resetOptions();
      this.$_updateStats();
    });

    this.$watch('trafficSourceFilter', () => {
      this.$refs.parentEntityDropdown.resetOptions();
      this.$_updateStats();
    });

    this.$watch('value', (value) => {
      this.model.entities = uniqBy(value.entities, 'id');
      this.model.type = value.type;
      this.$emit('input', this.model);
    }, { immediate: true });

    this.$watch('searchModel', () => {
      this.$_updateStats();
    });

    /* ********** Debounced Search ********** */
    this.$options.debounceSetSearchFunction = debounce((value) => {
      this.searchModel = value;
    }, 300);
    /* ************************************** */

    await this.$_updateStats();
  },
  methods: {
    getTrafficSourceLogo,
    async $_selectItem(item, value) {
      if (item.ids.length) {
        if (value) {
          const adgroups = await this.$_getEntityByIds(item.ids);
          this.$emit('input', { entities: uniqBy([...this.model.entities, ...adgroups], 'id'), type: this.model.type });
        } else {
          this.$refs.parentEntityDropdown.remove(item.ids);
          this.$emit('input', { entities: this.model.entities, type: this.model.type });
        }
      }
    },
    $_getItemContent(text, type) {
      return type ? `<span class="filter-item"><img src="${getTrafficSourceLogo(type)}" title="${type}" /> ${text}</span>` : `<span class="filter-item">${text}</span>`;
    },
    $_clearForm() {
      this.$c_platformFilter.forEach((item) => { item.selected = false; });
      this.$refs.selectorType.clear();
      this.$emit('input', { entities: [], type: null });
    },
    async $_addSearchCampaigns() {
      if (this.search) {
        const allIds = [];
        this.$c_filter.forEach(({ ids }) => { allIds.push(...ids); });
        const adGroups = await this.$_getEntityByIds(allIds);
        const payload = [...this.model.entities, ...adGroups];
        this.$emit('input', { entities: uniqBy(payload, 'id'), type: this.model.type });
      }
    },
    $_dropdownHidden() {
      this.searchModel = '';
    },
    async $_options(page = 1, search = '') {
      const payload = { page, search, model: this.model.parent_level };
      if (this.trafficSourceFilter && this.trafficSourceFilter.length) payload.typeName = this.trafficSourceFilter;
      if (this.trackerAccountFilter && this.trackerAccountFilter.length) payload.trackerAccountIds = this.trackerAccountFilter;
      if (this.customFilter) Object.assign(payload, this.customFilter);
      const data = await this.$api.entityFilter.getByStatus(payload);
      return data;
    },
    async $_updateStats() {
      const payload = { search: this.searchModel || '', model: this.model.parent_level };
      if (this.trafficSourceFilter && this.trafficSourceFilter.length) payload.typeName = this.trafficSourceFilter;
      if (this.trackerAccountFilter && this.trackerAccountFilter.length) payload.trackerAccountIds = this.trackerAccountFilter;
      if (this.customFilter) Object.assign(payload, this.customFilter);
      this.statsLoading = true;
      try {
        const stats = await this.$api.entityFilter.getStatusStatsGrouped(payload);
        this.search = payload.search || '';
        this.$set(this, 'stats', stats);
      } catch (error) {
        console.log(error);
      }
      this.statsLoading = false;
    },

    async $_getEntityByIds(ids = []) {
      if (ids.length) {
        const res = await this.$api.entityFilter.getByIds({ ids, model: this.model.parent_level });
        return res;
      }
      return [];
    },
  },
};
</script>
